<template>
  <div class="content-max-width flex flex-between">

    <section class="body-container">

      <article :class="{ 'active': step === 1}">
        <legend>1. Shipping Information</legend>
        <Shipping
          v-show="step === 1"
          :countries="countries"
          :regions="regions"
          :cart="cart"
          v-on:emitStep="changeStep"
        ></Shipping>

      </article>

      <article :class="{ 'active': step === 2}">
        <legend>2. Billing Information</legend>
        <Billing
          v-show="step === 2"
          :countries="countries"
          :regions="regions"
          :cart="cart"
          v-on:emitStep="changeStep"
        ></Billing>
      </article>


      <article :class="{ 'active': step === 3}">
        <legend>3. Confirm Order</legend>
        <Payment
          v-show="step === 3"
          :type="'dps'"
          :countries="countries"
          :regions="regions"
          :cash-sale-only="cashSaleOnly"
          v-on:emitStep="changeStep"
        ></Payment>
      </article>

    </section>

    <cart-summary
      :show-proceed="false"
    ></cart-summary>

  </div>
</template>

<script>
  import Shipping from './components/Shipping'
  import Billing from './components/Billing'
  import Payment from './components/Payment'

  export default {
    props: {
      countries: Array,
      regions: Array,
      cashSaleOnly: Number
    },

    components: {
      Shipping,
      Billing,
      Payment
    },

    data () {
      return {
        step: 1,
        cart: {}
      }
    },

    mounted () {
      this.cart = this.$store.state.cart
    },

    methods: {
      changeStep (toStep) {
        this.step = toStep
        document.getElementById('wrap').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
      }
    }
  }
</script>

<style lang="scss">
.page-checkout {

  .body-container {
    width: 100%;
    margin-bottom: 50px;

    @media (min-width: 768px) { width: 60%; }

    article {
      max-width: 800px;
      margin: 0 0 10px;
      padding: 10px;
      border-radius: 4px;

      legend {
        margin: 0;
        padding: 0 10px;

        font-size: 18px;
        font-weight: 600;
        // text-transform: uppercase;
      }

      .checkout-step-footer {
        width: 100%;
        display: inline-block;
        margin-top: 0;
        text-align: right;

        .button {
          max-width: 180px;

          padding: 5px 10px;
          @media (min-width: 768px) { padding: 5px 20px; }
        }
      }

      .form-field { padding-bottom: 20px; }
    }

    article.active {
      padding: 20px 10px 30px;

      background: #f9f9f9;

      @media (min-width: 768px) { padding: 20px 20px 30px; }

      legend {
        margin: 10px 0 20px;
        padding: 0;
      }
    }
  }

  aside.summary {
    width: 100%;
    margin-bottom: 50px;

    @media (min-width: 768px) {
      width: 40%;
      padding: 0 0 0 30px;
    }
    @media (min-width: 1023px) { padding: 0 0 0 80px; }

    .row {
      padding: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/Checkout.vue